export const parseHtml = (html) => {
  if (typeof DOMParser === 'undefined') {
    throw new Error(
      'The native `DOMParser` global which the `Html` serializer uses by default is not present in this environment.'
    )
  }

  const parsed = new DOMParser().parseFromString(html, 'text/html')
  // this is for PhantomJS, because it doesn't like DOMParser
  // and returns null, instead of body like a good modern browser.
  if (parsed === null) {
    return document.implementation.createHTMLDocument('test').body
  }
  const body = parsed.body

  return body
}

export default { parseHtml }
